<template>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <link rel="icon" type="image/png" href="favicon.png" />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      />
      <title>Restó APP</title>
    </head>
    <body class="page" style="overflow-y: scroll; height: 100vh">
      <Header :isRestoCompleto="!firstTime" ></Header>
      <div class="col-lg-8 mx-auto p-3 py-md-5">
   

        <div class="row">
    <div class="col-2"  >
      <a href="#"   @click="goToPage('Imagenes', $event)" v-if="!firstTime">
      <p class="h5 mb-2"> <b-icon-arrow-left></b-icon-arrow-left>Atrás</p>
    </a>
    </div>
    <div class="col-8">
      <h3>Imagenes Menu</h3>
    </div>
    <div class="col-2">
      <a href="#" v-if="1==2">
      <p class="h5 mb-2">Siguiente<b-icon-arrow-right></b-icon-arrow-right></p>
    </a>
    </div>
  </div>


        <hr class="" />
        <div>
          <div
            v-for="(image, index) in images"
            :key="index"
            class="mb-12 row fila"
          >
            <div class="col-sm-2">Imagen {{ index }}</div>

            <div class="col-sm-3">
              <img class="imagen" :src="image.imagen" alt="" />
            </div>

            <div class="col-sm-1" style="    font-size: 30px;">
              <i class="fa fa-trash" v-on:click="borrarImagen(image.id)"></i>
            </div>
          </div>
          <hr class="" />
          <div class="mb-6 row fila d-grid d-md-flex">
            <label for="file-upload" class="btn btn-primary col-sm-2">
              <i class="fa fa-cloud-upload"></i> Nueva Imagen
            </label>
            <div class="col-sm-2">
              <img class="imagen" :src="nuevaImagen" alt="" />
            </div>
            <input
              id="file-upload"
              @change="handleImage"
              type="file"
              accept="image/*"
              class="col-sm-4"
            />
          <hr>
         

          <div class="row" v-if="!existeLink">
          
  <div class="row"  >

<div class="col-2"><!----></div>
<div class="col-8"><h5 style="text-align: center;"> Link de menú
        </h5></div>

</div>

            <div class="col-12">
            <div class="input-group mb-3"  >


  <input type="text" class="form-control" placeholder="Agregar el link que te lleva a visualizar el menú" aria-label="Agregar link"   v-model="link" aria-describedby="button-addon2">
  <button class="btn btn-outline-secondary" type="button" id="button-addon2"
  @click="actualizarLink()" 
  >Guardar</button>


</div>

</div>

</div>

<div class="row" v-if="existeLink" >

  <div class="row"  >

    <div class="col-2"><!----></div>
    <div class="col-8"><h5 style="text-align: center;"> Link de menú
            </h5></div>
    
  </div>

<div class="col-12 ">
<div class="input-group mb-3"  >
 
<a :href="link" target="_blank" rel="noopener noreferrer" style="margin-top: 20px;">{{ link }}</a>
<button class="btn btn-outline-secondary" type="button" id="button-addon2" style="margin-left: 50px;"
  @click="existeLink=false" 
  >Modificar</button>
</div>

</div>

</div>


          </div>


        

<br><br><br>

          <div class="d-grid d-md-flex justify-content-md-center" v-if="firstTime" style="margin-top: 20px;">
              <button class="btn btn-primary" @click="goToPage('Imagenes', $event)" v-if="firstTime">
                Anterior
              </button>
              <button class="btn btn-primary btn-success" v-if="firstTime && images.length != 0" @click="finalizar()">
                Finalizar
              </button>
            </div>
        </div>
        <PopUp :show="success" @close="success = false;">
          <template #body>
            <p>{{ success_msg }}</p>
          </template>
        </PopUp>

        <PopUpEntendido :show="successentenedio" @close="successentenedio = false;volverAlInicio()">
          <template #body>
            <p>{{ success_entenedio_msg }}</p>
          </template>
        </PopUpEntendido>

        <PopUp :show="error" @close="error = false">
          <template #body>
            <p>{{ error_msg }}</p>
          </template>
        </PopUp>
      </div>

      <Footer />
    </body>
  </html>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import PopUp from "../components/PopUp.vue";
import PopUpEntendido from "../components/PopUpEntendido.vue";
import axios from "axios";
export default {
  components: { Header, Footer, PopUp,PopUpEntendido },
  data: function () {
    return {
      images: [],
      nuevaImagen: "",
      email: "",
      error: false,
      error_msg: "",
      success: false,
      success_msg: "",
      firstTime: false,
      isRestoCompleto:false,
      existeLink:false, 
      successentenedio:false,
      success_entenedio_msg:"",
      link:"",
    };
  },
  methods: {
    handleImage(e) {
      const selectedImage = e.target.files[0];
      this.createBase64Image(selectedImage).then(() => {
        this.agregarImagen();
      })
    },

    createBase64Image(fileObject) {
      return new Promise((resolve) => {
        const reader = new FileReader();
      reader.onload = () => {
        this.nuevaImagen = reader.result;
      resolve();
      };

      reader.readAsDataURL(fileObject);
      })

    },
    volverAlInicio() {
      this.$router.push({ name: "inicio"});
    },
    validateLink() {
      if (!this.link.startsWith("https://")) {
        this.error = true;
        this.error_msg = "Por favor, introduce una URL completa que comience con https://";
        return false;
      }
      return true;
    },
    actualizarLink(){
      if (!this.validateLink()) {
        return;
      }

      axios
        .post("/agregarImagenMenuLink", {link:this.link})
        .then((response) => {
          if (response.status == 200) {
            this.existeLink=true;
            this.success = true;
            this.success_msg = "Se ha logrado guardar el link con exito";
            this.nuevaImagen = "";
          } else {
            this.error = true;
            this.error_msg =
              " No se ha podido guardar el link. Intente nuevemente mas tarde";
          }
        });

    },
    agregarImagen() {
      this.error = false;
      if (this.nuevaImagen == "") {
        this.error = true;
        this.error_msg = " Primero seleccione una imagen";
        return;
      }
      let json = {
        imagen: this.nuevaImagen,
        orden: 0
      };
      axios
        .post("/agregarImagenMenu", json)
        .then((response) => {
          if (response.status == 200) {
            this.success = true;
            if(this.firstTime) {
              this.success_msg = "Imagen de menú cargada correctamente.";
            } else {
              this.success_msg = "Se ha logrado guardar la imagen con exito";
            }
            
            this.cargarImagenes();
            this.nuevaImagen = "";
          } else {
            this.error = true;
            this.error_msg =
              " No se ha podido guardar la imagen. Intente nuevemente mas tarde";
          }
        });
    },
    cancelar() {
      this.error = false;
      this.nuevaImagen = "";
    },
    borrarImagen(id) {
      this.error = false;
      let json = {
        id: id,
      };
      axios
        .post("/borrarImagenMenu", json)
        .then((response) => {
          if (response.status == 200) {
            this.success = true;
            this.success_msg = "Se ha borrado la imagen con exito";
            this.cargarImagenes();
          } else {
            this.error = true;
            this.error_msg =
              " No se ha podido borrar la imagen. Intente nuevemente mas tarde";
          }
        });
    },
    cargarImagenes() {
      axios
        .get(
          "/imagenesMenu/mail"
        )
        .then((data) => {
          if (data.status == 200) {
            this.images = data.data;
          }
        });
    },
    goToPage(page, $event) {
      this.$router.push({ name: page});
      $event?.preventDefault();
    },
   finalizar() {
  if (!this.email) {
    this.error = true;
    this.error_msg = "No se pudo finalizar correctamente. El correo electrónico no está definido.";
    return;
  }
  axios
    .post("/finalizar") 
    .then((response) => {
      if (response.status == 200) {
        this.successentenedio = true;
        this.success_entenedio_msg = "Felicitaciones! Ha terminado la carga de su restaurante.\n Se le ha otorgado un paquete de reservas gratuito de bienvenida, cuando quiera podrá acceder a la tienda para comprar más reservas.";
         this.firstTime = false;
      } else {
        this.error = true;
        this.error_msg = "No se pudo finalizar correctamente. Intente nuevamente más tarde";
      }
    });
},

    cargarLink(){
    axios
      .get("/restaurante/mail")
      .then((data) => {
        if (data.status == 200) {
          this.link=data.data.linkMenu;
          if(data.data.linkMenu!=null){
            this.existeLink=true;
          }
        }
      })
  }
  },
 
  beforeMount() {
   
    this.cargarImagenes();
    this.cargarLink();

    axios
  .get("/getUsuario")
  .then((data) => {
    console.log(data);  
    if (data.status == 200) {
      this.email = data.data.mail;
      console.log(this.email);
    }
  })
  .catch((w) => {
    console.log(w);
    this.error = true;
    this.error_msg = "No se ha podido actualizar la informacion. Vuelva a intentar mas tarde";
  });
  },
};
</script>
<style >
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import "../../node_modules/vue2-timepicker/dist/VueTimepicker.css";
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

.imagen {
  max-height: 60px;
  display: block;
}

input[type="file"] {
  display: none;
}
.custom-file-upload {
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  background-color: blue;
}
.btn {
  height: 60px;
}

.fila {
  max-height: 100px;
  padding: 6px 0px;
}
:host {
  --main-color: #0047b3;
  --second-color: #0198f3;
  --grey-color: #f5f8fa;
  --border-radius-1: 9px;
  --border-radius-2: 6px;
}
body {
  font-family: "Inter", sans-serif;
  color: #083744;
  font-size: 14px;
  height: 100%;
}
.btn-primary{
  margin: 15px;
}
</style>
